import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import { store } from 'store';
import App from 'App';
import 'global/fonts.css';
import 'global/styles.css';
import 'global/variables.css';

if (!!+process.env.PRODUCTION) {
    ReactGA.initialize(process.env.GOOGLE_ANALYTICS_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
        <BrowserRouter>
            {!!+process.env.PRODUCTION
              ? <Helmet>
                    <title>
                        Digital SAT Online Preparation - The SAT Crash Course
                    </title>
                    <meta 
                        name="description" 
                        content="Prepare for the Digital SAT online in the shortest time! Take our crash courses and practice tests and get the most effective skills you need to tackle the test."
                    ></meta>
                    {/* <script
                        async
                        src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GOOGLE_ANALYTICS_ID}`}
                    ></script>
                    <script>
                        {`
                            window.dataLayer = window.dataLayer || [];
                            function gtag(){dataLayer.push(arguments);}
                            gtag('js', new Date());

                            gtag('config', ${process.env.GOOGLE_ANALYTICS_ID});
                        `}
                    </script> */}
                    <script>
                        {/* Hotjar Tracking Code for https://study.thesatcrashcourse.com */}
                        {`
                            (function(h,o,t,j,a,r) {
                                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                                h._hjSettings={hjid:3456110,hjsv:6};
                                a=o.getElementsByTagName('head')[0];
                                r=o.createElement('script');r.async=1;
                                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                                a.appendChild(r);
                            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                        `}
                    </script>
                </Helmet>
              : <Helmet>
                    <title>
                        Digital SAT Online Preparation - The SAT Crash Course
                    </title>
                    <meta 
                        name="description" 
                        content="Prepare for the Digital SAT online in the shortest time! Take our crash courses and practice tests and get the most effective skills you need to tackle the test."
                    ></meta>
                    <meta name='robots' content='noindex'></meta>
                </Helmet>
            }
            <App />
        </BrowserRouter>
    </Provider>
);